//CONSTANT VARIABLE
export const CHAIN_ID = 97
export const RPC_URL =  "https://data-seed-prebsc-1-s1.binance.org:8545/"
export const CONTRACT_INSTANCE = "0xdc456bd857ff01d677135203d38945a693330211"
export const VIEW_CONTRACT = "https://testnet.bscscan.com/"
